import us_pc from "./../../assets/images/us_pc.webp";
import us_mo from "../../assets/images/us_mo.webp";

import ar_white from "../../assets/images/ar_white.svg";
import home_white from "../../assets/images/home_white.svg";

export default function ContactUsBanner() {
  return (
    <div className="w-full">
      <div className="block md:hidden lg:hidden w-full relative h-[12rem] mt-16">
        <img src={us_mo} alt="mobi" className="w-full h-[12rem] object-cover" />
        <div className="w-full absolute top-0 h-[12rem] bg-blue-sky-gradient6">
          <div className="absolute bottom-[20%] left-1/2 -translate-x-1/2 flex flex-col gap-2 items-center justify-center px-4">
            <div className="w-full max-w-xs h-[2.625rem] rounded-[40px] flex items-center gap-2 justify-center">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" className="w-5 h-5" />
                <img src={ar_white} alt="ar" className="w-4 h-4" />
              </div>
              <div>
                <p className="text-sm md:text-base font-normal text-white">Liên hệ</p>
              </div>
            </div>
            <p className="text-xl md:text-2xl font-semibold text-white text-center">
              Liên hệ với chúng tôi
            </p>
          </div>
        </div>
      </div>
      <div className="hidden md:block lg:block w-full relative h-[20rem] mt-28">
        <img src={us_pc} alt="pc" className="w-full h-[20rem] object-cover" />
        <div className="w-full absolute top-0 h-[20rem] bg-blue-sky-gradient6">
          <div className="absolute bottom-[35%] left-1/2 -translate-x-1/2 flex flex-col gap-2 items-center justify-center px-4">
            <div className="w-full max-w-md h-[2.625rem] rounded-[40px] flex items-center justify-center gap-2">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" className="w-5 h-5" />
                <img src={ar_white} alt="ar" className="w-4 h-4" />
              </div>
              <div>
                <p className="text-sm md:text-base font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" className="w-4 h-4" />
              <div>
                <p className="text-sm md:text-base font-normal text-white">
                  Liên hệ
                </p>
              </div>
            </div>
            <p className="text-2xl md:text-3xl lg:text-4xl font-semibold text-white text-center">
              Liên hệ với chúng tôi
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
